import { baseScopesRequiredPerField } from '@atlassian/ui-modifications-core/constants';
import { isAriResourceIdValid } from '@atlassian/ui-modifications-public-api-utils/is-ari-resource-id-valid';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export type RadioButtonsPublicSetValue = null | string;

export type RadioButtonsPublicGetValue = {
	id: string;
	value: string;
} | null;

export const radioButtonsSetValueValidator = (
	value: unknown,
): value is RadioButtonsPublicSetValue => value === null || isNotEmptyString(value);

export const validateRadioButtonsWithAriSetValue = (
	value: unknown,
): value is RadioButtonsPublicSetValue =>
	value === null || (isNotEmptyString(value) && isAriResourceIdValid(value));

export const radioButtonsScopes = baseScopesRequiredPerField;
